import { EEnvironment, envVars } from '@/config';
import { ClientStorage } from './clientStorage';

const STRIPE_ACCOUNT_ID = 'acct_16tNGEBMTSmKGzYQ';

export type StripeDashboardPath = 'customers' | 'payments' | 'invoices' | 'subscriptions';

/**
 * Stripe dashboard link for an object. Dev/local servers run on Stripe test keys, so the
 * link points at test mode whenever the app talks to one (same switch as the Apollo link).
 */
export const stripeDashboardUrl = (path: StripeDashboardPath, id: string) => {
  const savedEnv = ClientStorage.local.getItem<EEnvironment>('ques-envMode') || EEnvironment.PRODUCTION;
  const isTestMode = savedEnv === EEnvironment.DEVELOPMENT || envVars.be.isDev;
  return `https://dashboard.stripe.com/${STRIPE_ACCOUNT_ID}${isTestMode ? '/test' : ''}/${path}/${id}`;
};
